<template lang="html">
  	<entity-page id="page__extrasize" v-bind:loading="progress">
      	<template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded @click="save"></z-icon-button>
        </template>

		<z-select
			label="Тип расчёта" v-model="extrasize.type" :required="true" name="type" id="type"
			v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('type')"
		>
			<option v-bind:value="null"> Выбрать... </option>
			<option value="weight"> По весу </option>
			<option value="volume"> По объёму </option>
		</z-select>

		<z-select
			label="Тип наценки" v-model="extrasize.markup_type" :required="true" name="markup_type" id="markup_type"
			v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('markup_type')"
		>
			<option v-bind:value="null"> Выбрать... </option>
			<option v-bind:value="1"> Числовая </option>
			<option v-bind:value="2"> Процентная </option>
		</z-select>
		<z-input
			v-model="extrasize.markup_value" label="Величина наценки" name="markup_value" id="markup_value"
			v-validate="{'required': true, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}" 
			v-bind:required="true" v-bind:error="errors.first('markup_value')" type="number" data-vv-name="markup_value" v-bind:data-vv-as="' '"
		></z-input>

		<z-input
			v-model="extrasize.min" label="Минимум (кг/м<sup>3</sup>)" name="min" id="min"
			v-validate="{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}" 
			v-bind:required="true" v-bind:error="errors.first('min')" type="number" data-vv-name="min" v-bind:data-vv-as="' '"
		></z-input>
		<z-input
			v-model="extrasize.max" label="Максимум (кг/м<sup>3</sup>)" name="max" id="max"
			v-validate="{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}" 
			v-bind:required="true" v-bind:error="errors.first('max')" type="number" data-vv-name="max" v-bind:data-vv-as="' '"
		></z-input>


		<z-input-autocomplete
			property="id" return="id" display-property="name" 
			name="way_id" id="way_id" type="type"
			placeholder="Направление*" label="Направление*"
			v-model="extrasize.way_id" v-bind:default="extrasize.way_name"
			v-bind:callback="searchWay" v-bind:required="true"
			v-validate="'required'"
			v-bind:error="errors.first('way_id')" data-vv-name="way_id" v-bind:data-vv-as="' '"
		></z-input-autocomplete>
	</entity-page>
</template>

<script>
	import ZInput from '@/components/ZInput';
	import ZSelect from '@/components/ZSelect';
	import ZInputAutocomplete from '@/components/ZInputAutocomplete';
	import EntityPage  from '@/components/EntityPage.vue';
	import ZIconButton from '@/components/ZIconButton';
	export default {
		components: {ZInputAutocomplete, ZInput, ZSelect, EntityPage, ZIconButton},
		data() {
			return {
				title: 'Негабарит',
				extrasize: {
					type: '',
					markup_type: 1,
					markup_value: 0,
					min: 1,
					max: 2
				},
				defaultExtrasize: {
					type: '',
					markup_type: 1,
					markup_value: 0,
					min: 1,
					max: 2,
					way_name: ''
				},
				ways: [],
				type: null
			}
		},
		computed: {
			extrasizes() {
				return this.$store.state.cost.extrasizes;
			},
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['load-wayextrasize-card'];
			},
			/**
			 * Объект с флагами загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
		},
		watch: {
			'$route.params.setting_id'() {
				this.init();
			},
		},
		created() {
			this.init();
		},
		methods: {
			/**
			 * Получение направления
			 */
			searchWay(str) {
				let filter = {
					relation: [
						['zoneFrom', 'name', '%', str], 'or',
						['zoneTo',   'name', '%', str], 'or',
						['cityFrom', 'name', '%', str], 'or',
						['cityTo',   'name', '%', str], 
					],
					condition: 'or'
				};
				return this.$store.dispatch('cost/getPrices', {page: 1, order_by: 'id', order_type: 'asc', count: 10, filter: filter}).then(r => {
					let result = [];
					r.data.filter((item) => {
						if (this.extrasize.type == 'weight') return parseInt(item.type) == 1;
						else return parseInt(item.type) == 2;
					}).map(item => {
						let name = '';
						name += (item.zone_from) ? item.zone_from.name : ((item.city_from) ? item.city_from.name : '');
						name += ' - ';
						name += (item.zone_to) ? item.zone_to.name : ((item.city_to) ? item.city_to.name : '');
						name += (parseInt(item.is_min) == 1) ? ', Мин: да' : ', Мин: нет';
						name += (parseInt(item.type) == 1) ? ', по весу' : ', по объёму';

						name += (parseInt(item.volume_min) > 0) ? (', Объём мин: '  + item.volume_min) : '';
						name += (parseInt(item.volume_max) > 0) ? (', Объём макс: ' + item.volume_max) : '';
						name += (parseInt(item.weight_min) > 0) ? (', Вес мин: '  + item.weight_min) : '';
						name += (parseInt(item.weight_max) > 0) ? (', Вес макс: ' + item.weight_max) : '';

						result.push({id: item.id, name: name});
					});

					
					return result;
				});
			},
			/**
			 * Получение цены
			 */
			getExtrasize() {
				if (this.$route.params.setting_id != 'new') {
					this.$store.commit('showProgressBar', 'load-wayextrasize-card');
					this.$store.dispatch('cost/getExtrasize', {
						id: this.$route.params.setting_id
					}).then((response) => {
						this.extrasize = Object.assign({}, response);
						this.extrasize.way_name = '';
						if (this.extrasize.way) {
							this.extrasize.way_name += (this.extrasize.way.zone_from) ? this.extrasize.way.zone_from.name : ((this.extrasize.way.city_from) ? this.extrasize.way.city_from.name : '');
							this.extrasize.way_name += ' - ';
							this.extrasize.way_name += (this.extrasize.way.zone_to) ? this.extrasize.way.zone_to.name : ((this.extrasize.way.city_to) ? this.extrasize.way.city_to.name : '');
						}
					}).finally(() => this.$store.commit('hideProgressBar', 'load-wayextrasize-card'));
				} else this.extrasize = Object.assign({}, this.defaultExtrasize);
			},
			/**
			 * Получение цен
			 */
			getExtrasizes() {
				this.$store.dispatch('cost/getExtrasizes');
			},
			/**
			 * Инициализация компонента
			 */
			init() {
				this.$store.commit('setTitle', this.title);
				this.getExtrasize();
				this.$store.commit('openRightPanel');
			},
			/**
			 * Добавление цены
			 */
			postExtrasize() {
				this.$store.commit('showProgressBar', 'load-wayextrasize-card');
				this.$store.dispatch('cost/postExtrasize', this.extrasize).then(r => {
					if (!r) return;
					this.$root.$emit('reload-table', 'freightextrasize');
					this.$router.replace({name: 'WayExtrasizes', params: {setting_id: r.id}});
				}).finally(() => this.$store.commit('hideProgressBar', 'load-wayextrasize-card'));
			},
			/**
			 * Изменение цены 
			 */
			putExtrasize() {
				this.$store.commit('showProgressBar', 'load-wayextrasize-card');
				this.$store.dispatch('cost/putExtrasize', this.extrasize).then(r => {
					if (!r) return;
					this.init();
					this.$root.$emit('reload-table', 'freightextrasize');
				}).finally(() => this.$store.commit('hideProgressBar', 'load-wayextrasize-card'));
			},
			/**
			 * Сохранение
			 */
			save() {
				this.$validator.validateAll().then((valid) => {
					if (!valid) return;
					if (!this.extrasize.id || this.extrasize.id == 'new') this.postExtrasize();
					else this.putExtrasize();
				});
			},
			/**
			 * Возвращает пользователя на предыдущую страницу
			 * Обрабочик события click, на кнопке "Закрыть"
			 */
			back() {
				this.$router.push({name: 'WayExtrasizes', query: this.$route.query});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// WayFreightExtrasize.vue?3f1fa8b6